import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { eventsService } from './_deps';

export const removeFromEvent = createAsyncThunk<
  void,
  { eventId: string; telegramIds: number[] },
  { state: RootState }
>('events/removeParticipants', async (params, thunkApi) => {
  const { dispatch } = thunkApi;
  const updatedEvent = await eventsService.removeFromEvent({
    eventId: params.eventId,
    telegramIds: params.telegramIds,
  });
  dispatch(entitiesActions.upsertEvent(updatedEvent));
});
